<template>
  <v-col cols="12" :md="md">
    <v-container>
      <v-row>
        <p><b>{{customerName}}</b></p>
      </v-row>
      <v-row>
        <p>{{item.advert.name}}</p>
      </v-row>
      <v-row>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              :color="playWithBudgetColor"
              small>euro</v-icon>
          </template>
          <span>{{$t('display/advert:statistic.play-with-budget')}}</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              :color="playWithoutBudgetColor"
              small>remove_shopping_cart</v-icon>
          </template>
          <span>{{$t('display/advert:statistic.play-without-budget')}}</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              :color="endedWithBudgetColor"
              v-bind="attrs"
              v-on="on"
            >
              payment
            </v-icon>
          </template>
          <span>{{$t('display/advert:statistic.ended-with-remaining-budget')}}</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              :color="endedWithoutBudgetColor"
              dark
              v-bind="attrs"
              v-on="on"
            >
              money_off
            </v-icon>
          </template>
          <span>{{$t('display/advert:statistic.ended-without-remaining-budget')}}</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              :color="constraintsColor"
              dark
              v-bind="attrs"
              v-on="on"
            >play_disabled</v-icon>
          </template>
          <span>{{$t('display/advert:statistic.not-played-constraints')}}</span>
        </v-tooltip>
      </v-row>
    </v-container>
  </v-col>
</template>
<script>
export default {
  name: "NameField",
  props: {
    item: Object,
    md: String
  },
  computed: {
    customerName() {
      return this.item.advert.customer !== null ? this.item.advert.customer.name : '';
    },
    privateColor() {
      return 'grey';
    },
    constraintsColor() {
      return this.item.advertState === 'STATE_WHITE' ? 'pink' : 'grey';
    },
    endedWithoutBudgetColor() {
      return this.item.advertState === 'STATE_BLACK' ? 'black' : 'grey';
    },
    endedWithBudgetColor() {
      return this.item.advertState === 'STATE_RED' ? 'red' : 'grey';
    },
    playWithoutBudgetColor() {
      return this.item.advertState === 'STATE_YELLOW' ? 'orange' : 'grey';
    },
    playWithBudgetColor() {
      return this.item.advertState === 'STATE_GREEN' ? 'green' : 'grey';
    }
  }
}
</script>
